<mat-toolbar>

  <button (click)="previousWeek()" class="left-date-browser" mat-icon-button>
    <mat-icon fontIcon="fa-chevron-left" fontSet="fas"></mat-icon>
  </button>
  <mat-form-field class="date-form-field">
    <input (dateChange)="selectDate($event);" [formControl]="date" [matDatepicker]="dp" matInput />
    <mat-datepicker-toggle [for]="dp" [ngClass]="'picker-button'" [style.color]="'white'"
      matSuffix></mat-datepicker-toggle>
    <mat-datepicker #dp disabled="false" touchUi="true"></mat-datepicker>
  </mat-form-field>
  <button (click)="nextWeek()" class="right-date-browser" mat-icon-button>
    <mat-icon fontIcon="fa-chevron-right" fontSet="fas"></mat-icon>
  </button>
  <span class="spacer"></span>
  <button (click)="openBulkWizard()" mat-icon-button matTooltip="Bulk Availability Update Wizard">
    <mat-icon>add</mat-icon>
  </button>
  <a [routerLink]="['../day']" color="accent" mat-flat-button>Day View</a>
</mat-toolbar>
<div id="divisionGrid"></div>
